import SAVE_OPTIN from './saveOptIn.gql';
import GENERATE_PROOF_OF_CIVIL_STATUS from './generateProofOfCivilStatus.gql';

export { SAVE_OPTIN, GENERATE_PROOF_OF_CIVIL_STATUS };
